import { render, staticRenderFns } from "./invite_red.vue?vue&type=template&id=7a45f809&scoped=true&"
import script from "./invite_red.vue?vue&type=script&lang=js&"
export * from "./invite_red.vue?vue&type=script&lang=js&"
import style0 from "./invite_red.vue?vue&type=style&index=0&id=7a45f809&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a45f809",
  null
  
)

export default component.exports